import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  clearPwaLaunchPathIfMatches,
  peekPwaLaunchPath,
  subscribeToPwaLaunch,
} from '../utils/pwa-launch';

export const PwaLaunchNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationRef = useRef(location);
  locationRef.current = location;

  useEffect(() => {
    const apply = (path: string): void => {
      const current = `${locationRef.current.pathname}${locationRef.current.search}${locationRef.current.hash}`;
      if (current === path) {
        return;
      }
      navigate(path);
    };

    const pending = peekPwaLaunchPath();
    if (pending) {
      apply(pending);
    }

    return subscribeToPwaLaunch(apply);
  }, [navigate]);

  useEffect(() => {
    clearPwaLaunchPathIfMatches(`${location.pathname}${location.search}${location.hash}`);
  }, [location.pathname, location.search, location.hash]);

  return null;
};
